export const blockIconsCommonactionsInfoNew = (
	<span className='material-symbols-outlined'>info</span>
);
